import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ChallengesListingPageComponent, CreateNewChallengeDetailsComponent, MilestoneSummaryViewComponent, SettingUpNewMilestoneConfigComponent } from "./pages";

const routes: Routes = [
  { path: "", redirectTo: "listing", pathMatch: "full" },
  {
    path: "listing",
    component: ChallengesListingPageComponent,
    data: {
      titleheading: "Challenge",
      title: "Challenge",
      minPath: "Basic",
    },
  },
  {
    path: "create-new",
    component: CreateNewChallengeDetailsComponent,
    data: {
      titleheading: "Challenge",
      title: "Create New Challenge",
      minPath: "Basic",
    },
  },
  {
    path: 'create-new-milestone',
    component: SettingUpNewMilestoneConfigComponent,
    data: {
      titleheading: "Milestone",
      title: "Create New Milestone",
      minPath: "Basic",
    },
  },
  {
    path: 'view-challenge',
    component: MilestoneSummaryViewComponent,
    data: {
      titleheading: "Challenge Summary",
      title: "Challenge Summary",
      minPath: "Basic",
    },
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ChallengesRoutingModule {}
